const defaultConfig = {
  preTag: '<em>',
  postTag: '</em>',
};

export function extractHighlightedWordsFromString(
  str: string | number,
  config: { preTag: string; postTag: string } = defaultConfig,
): Array<{ highlighted: boolean; value: string }> {
  const results = [];
  let stringCursor = String(str);
  while (stringCursor.length > 0) {
    const highlightWordPreTag = stringCursor.indexOf(config.preTag);
    if (highlightWordPreTag > -1) {
      const highlightWordPostTag = stringCursor.indexOf(config.postTag);
      if (highlightWordPreTag > 0) {
        results.push({
          highlighted: false,
          value: stringCursor.slice(0, highlightWordPreTag),
        });
      }
      results.push({
        highlighted: true,
        value: stringCursor.slice(
          highlightWordPreTag + config.preTag.length,
          highlightWordPostTag,
        ),
      });
      stringCursor = stringCursor.slice(
        highlightWordPostTag + config.postTag.length,
      );
    } else {
      results.push({
        highlighted: false,
        value: stringCursor,
      });
      stringCursor = '';
    }
  }
  return results;
}
